import styled from 'styled-components';

export const ModalContainer = styled.div`
  position: fixed;
  z-index: 9009;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    font-size: 46px;
    margin: 0 0 30px;
  }

  h3 {
    font-size: 22px;
    margin: 0 0 30px;
  }

  .users-form {
    img {
      object-fit: cover;
    }

    select {
      option {
        padding: 0;
      }
    }
  }

  & > div {
    position: relative;
    border-radius: 4px;
    background-color: #ffffff;
    width: 440px;
    padding: 48px;

    button.close {
      position: absolute;
      top: 20px;
      right: 20px;
      padding: 0;
      margin: 0;
    }

    label {
      margin: 23px 0;
    }

    [type='button'] {
      font-size: 16px;
      padding: 14px 40px;
    }

    img {
      border-radius: 50%;
      margin-bottom: 15px;
    }

    .avatars {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin: 0 -5% 50px;

      button {
        position: relative;
        padding: 12px 0;
        width: 20%;

        &::before {
          content: '';
          position: absolute;
          z-index: 1;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        span {
          display: none;
        }

        img {
          margin: 0;
        }

        &:hover {
          img {
            transform: scale(1.05);
          }
        }

        &.selected {
          img {
            transform: scale(1.2);
          }

          span {
            display: inline-block;
            position: absolute;
            bottom: 0;
            right: 0;
            height: 16px;
            width: 16px;
            background-color: ${({ theme: { colors } }) => colors.blue};
            border-radius: 50%;
            font-size: 10px;
            line-height: 1.7;
            color: #ffffff;
            box-sizing: content-box;
            border: 3px solid #ffffff;
          }
        }
      }
    }
  }
`;
